<div class="filter-location">
  <div *ngIf="label" class="lum-label">{{ label }}</div>

  <mat-form-field
    [ngClass]="{ 'filter-location-inline': inlineChips }"
    class="filter-location__chip-list w-100"
    appearance="outline"
  >
    <mat-chip-list #chipList aria-label="Location selection">
      <mat-chip *ngFor="let location of selectedLocations" class="lum-chip">
        <div class="filter-location__chip-list-label">
          {{ location?.label }}
        </div>
        <button matChipRemove (click)="onRemove(location)">
          <lum-ui-icon
            icon="close-circle"
            [width]="18"
            [height]="18"
            color="#000000"
          ></lum-ui-icon>
        </button>
      </mat-chip>
      <input
        class="filter-location__input"
        [(ngModel)]="value"
        [placeholder]="placeholder"
        #locationInput
        [formControl]="locationControl"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      />
    </mat-chip-list>
    <mat-autocomplete #auto="matAutocomplete">
      <mat-option
        *ngFor="let location of uniqueFilteredLocations"
        [value]="location?.label"
        (click)="onAdd(location)"
      >
        {{ location?.label }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</div>
